import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme ,headerHeight}) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
        minWidth: "150px",
        overflowX: "hidden",
        // height: "calc(100% - 60px)",
        height: headerHeight?`calc(100% - ${headerHeight}px)`:"calc(100% - 60px)",
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
    "& .MuiDialog-paper": {
        width: "360px",
        height: "608px",
    },
    "& .MuiPaper-elevation": {
        maxWidth: "100%",
        display: "block",
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, displayBack, ...other } = props;

    const handleBackClick = () => {
        const incomeEvent = new CustomEvent("model-back-click");
        document.dispatchEvent(incomeEvent);
    };

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            <></>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

const MobileModal = (props) => {
    const { onClose, removeTabIndex, fullScreen, displayBack, open, onBackClick, displayTopBorder,DialogContentSx={}, ...other } = props;

    useEffect(() => {
        if (open === true && removeTabIndex) {
            setTimeout(() => {
                let red = document.querySelector(".MuiDialog-container");
                if (red) {
                    red.removeAttribute("tabindex");
                }
            }, 100);
        }
    }, [open, removeTabIndex]);

    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        onClose();
    };

    return (
        <div>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                {...props}
                tabIndex={false}
                fullScreen={fullScreen}
                disableEscapeKeyDown
                onClose={handleClose}
                headerHeight={props.headerHeight||60}>
                {!props.hideTitle && (
                    <BootstrapDialogTitle
                        displayBack={displayBack}
                        frontAction={true}
                        id="customized-dialog-title"
                        onClose={handleClose}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Box sx={{ color: "#164C63" }}>{other.header ? other.header : props.title}</Box>
                        </Box>
                    </BootstrapDialogTitle>
                )}
                <DialogContent
                    sx={{
                        minWidth: "500px",
                        overflowX: "hidden",
                        borderTop: displayTopBorder ? "1px solid #EAECF0" : "none",
                        ...DialogContentSx
                    }}>
                    {props.children}
                </DialogContent>
            </BootstrapDialog>
        </div>
    );
};

export { MobileModal };
